/**
 * Legacy aggregate exports for the Clockodo SDK.
 *
 * @module
 */
export * from "./models/absence.js";
export * from "./models/access.js";
export * from "./models/accessControl.js";
export * from "./models/accessGroup.js";
export * from "./models/aggregatesUsersMe.js";
export * from "./models/company.js";
export * from "./models/customerCountProjects.js";
export * from "./models/customer.js";
export * from "./models/dateTime.js";
export * from "./models/entriesText.js";
export * from "./models/entry.js";
export * from "./models/entryGroup.js";
export * from "./models/holidaysCarryover.js";
export * from "./models/holidaysQuota.js";
export * from "./models/lumpsumService.js";
export * from "./models/nonbusinessDay.js";
export * from "./models/nonbusinessGroup.js";
export * from "./models/overtimeReduction.js";
export * from "./models/overtimecarry.js";
export * from "./models/project.js";
export * from "./models/service.js";
export * from "./models/subproject.js";
export * from "./models/surchargeModel.js";
export * from "./models/subscription.js";
export * from "./models/targethours.js";
export * from "./models/team.js";
export * from "./models/user.js";
export * from "./models/usersNonbusinessGroup.js";
export * from "./models/userReport.js";
export * from "./models/worktimeRegulation.js";
export * from "./models/workTimes.js";

export {
  mapQueryParams,
  mapRequestBody,
  mapResponseBody,
} from "./lib/mappings.js";

export type { Config, Paging, Filter } from "./lib/api.js";
export * from "./clockodo.js";
